import React, { memo } from 'react'
import PropTypes from 'prop-types'

const Polygon = ({ section }) => {
  const heptagon =
    'M355.3 10.512a90 90 0 0179.4 0l243.16 119.513a90 90 0 0148.132 61.129l60.721 271.517a90 90 0 01-16.913 75.056L600.487 754.413A90 90 0 01529.569 789H260.431a90 90 0 01-70.918-34.586L20.2 537.727a90 90 0 01-16.913-75.056l60.721-271.517a90 90 0 0148.132-61.129z'
  const octagon =
    'M542.46.013c15.121 0 22.647 6.488 27.719 11.56l207.841 207.76c3.226 5.583 11.98 15.316 11.98 29.12v292.794a43 43 0 01-11.98 29.124L570.179 778.126c-8.147 8.147-14.782 11.56-27.719 11.56H247.54c-15.357 0-22.042-5.882-27.719-11.56L11.979 570.371A42.53 42.53 0 010 541.247V248.453c0-11.9 4.02-21.164 11.979-29.124L219.821 11.573C229.5 1.899 237.183.013 247.54.013z'
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 790 790'>
      <defs>
        <clipPath id="polygonpath">
          <path d='M0 0h790v790H0z'></path>
        </clipPath>
      </defs>
      <g
        clipPath={`url(${window.location.protocol}//${window.location.host}${window.location.pathname}#polygonpath`}>
        <path
          d={['intro', 'quienes-somos'].includes(section) ? heptagon : octagon}
        />
      </g>
    </svg>
  )
}

Polygon.propTypes = {
  section: PropTypes.string.isRequired,
}

export default memo(Polygon)
